    // frontend/src/App.js
    import React from 'react';
    import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
    import AppNavbar from './components/Layout/Navbar';
    import LoginPage from './components/Auth/LoginPage';
    import HomePage from './components/Pages/HomePage';
    import ProtectedRoute from './components/ProtectedRoute';
    import authService from './services/authService';

    // Import your page components
    import Dashboard2Party from './components/Pages/Dashboard2Party';
    import DashboardGeodesy from './components/Pages/DashboardGeodesy';
    import DashboardGeneral from './components/Pages/DashboardGeneral';
    import DashboardAdmin from './components/Pages/DashboardAdmin'; // <-- IMPORT Admin Page

    const GenericPage = ({ title }) => <div className="container mt-3"><h1>{title}</h1><p>Content for {title}</p></div>;

    function App() {
        const currentUser = authService.getCurrentUser();

        return (
            <Router>
                <AppNavbar />
                <div className="container-fluid mt-3 px-md-4">
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route element={<ProtectedRoute />}>
                            <Route path="/home" element={<HomePage />} />
                            <Route path="/2party" element={<Dashboard2Party />} />
                            <Route path="/geodesy" element={<DashboardGeodesy />} />
                            <Route path="/general" element={<DashboardGeneral />} />
                            <Route path="/admin-dashboard" element={<DashboardAdmin />} /> {/* <-- ADDED Admin Route */}
                            
                            {/* Other specific routes */}
                            <Route path="/1party" element={<GenericPage title="1Party Page"/>} />
                            <Route path="/3party" element={<GenericPage title="3Party Page"/>} />
                            <Route path="/4party" element={<GenericPage title="4Party Page"/>} />
                            <Route path="/5party" element={<GenericPage title="5Party Page"/>} />
                            <Route path="/1carto" element={<GenericPage title="1Carto Page"/>} />
                            <Route path="/2carto" element={<GenericPage title="2Carto Page"/>} />
                            <Route path="/photo-office" element={<GenericPage title="Photo Office Page"/>} />
                            <Route path="/gis" element={<GenericPage title="GIS Page"/>} />
                            <Route path="/digital-carto" element={<GenericPage title="Digital Carto Page"/>} />
                            <Route path="/boundary-section" element={<GenericPage title="Boundary Section Page"/>} />
                            <Route path="/director-office" element={<GenericPage title="Director Office Page"/>} />
                            <Route path="/dpco" element={<GenericPage title="DPCO Page"/>} />
                            <Route path="/cpt" element={<GenericPage title="CPT Page"/>} />
                            <Route path="/lpo" element={<GenericPage title="LPO Page"/>} />
                            {/* Remove the generic /admin route if /admin-dashboard is the specific one */}
                        </Route>
                        <Route
                            path="/"
                            element={currentUser ? <Navigate to="/home" /> : <Navigate to="/login" />}
                        />
                        <Route
                            path="*"
                            element={<Navigate to={currentUser ? "/home" : "/login"} />}
                        />
                    </Routes>
                </div>
            </Router>
        );
    }

    export default App;
    